// create a component that will display the Title of the website
const Header = () => {
    return (
        <header className="header">
            <h1>The Local Weather App ⚡<span className="white">☁</span></h1>
        </header>
    )
}

export default Header;